import { CheckCircleIcon, CircleCrossIcon, TrashIcon } from '@fukuri-admins/ui/common';
import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import clsx from 'clsx';
import React, { useState } from 'react';
import { cancelRedeemableStoreCouponHistory } from '../../../apis/redeemableStoreCouponHistories/id';
import { RedeemableStoreCouponHistoryTableData } from '../../../types/redeemableStoreCouponHistory/RedeemableStoreCouponHistoryTableData';
import { formatCurrency } from '../../../utils/formatCurrency';
import { CancelModal } from '../CancelModal';
import styles from './styles.module.scss';

type Props = {
  rows: RedeemableStoreCouponHistoryTableData[];
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const RedeemableStoreCouponHistoryMobileCardList: React.FC<Props> = ({
  rows,
  setIsLoading,
}) => {
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [targetIdToCancel, setTargetIdToCancel] = useState<number | null>(null);
  const { showToast } = useToast();

  const onCancel = async () => {
    if (targetIdToCancel === null) return;
    try {
      setIsLoading(true);
      const target = rows.find(row => row.id === targetIdToCancel);
      await cancelRedeemableStoreCouponHistory(target.id, target.three_letter_code);
      showToast({
        message:
          '利用キャンセルが完了しました。※現在の入金金額がキャンセル金額に満たない場合、入金金額がキャンセル金額を上回った時点で自動的に引き落とされます。',
        status: 'success',
      });
    } finally {
      setIsLoading(false);
      setIsCancelModalOpen(false);
    }
  };

  if (!rows || rows.length === 0) {
    return <div className={styles.emptyCardList}>データなし</div>;
  }

  return (
    <>
      <div className={styles.cardListContainer}>
        {rows.map((row, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.cardLeft}>
              <div className={clsx(row.is_cancelled ? styles.cancelled : styles.uncancelled)}>
                {row.is_cancelled ? <CircleCrossIcon size='sm' /> : <CheckCircleIcon size='sm' />}
              </div>
              <div className={styles.cardColumn}>
                <div className={styles.cardBranch}>{row.branch}</div>
                <div className={styles.cardValue}>{row.redeemed_at}</div>
              </div>
            </div>
            <div className={styles.cardRight}>
              <div className={styles.cardAmount}>{formatCurrency(row.amount)}</div>
              <button
                type='button'
                className={styles.cancelButton}
                onClick={() => {
                  setTargetIdToCancel(row.id);
                  setIsCancelModalOpen(true);
                }}
                disabled={row.is_cancelled}
              >
                <TrashIcon size='xs' />
              </button>
            </div>
          </div>
        ))}
      </div>
      <CancelModal
        isCancelModalOpen={isCancelModalOpen}
        setIsCancelModalOpen={setIsCancelModalOpen}
        onCancel={onCancel}
      />
    </>
  );
};
